var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification is-warning"},[(_vm.admin)?_c('button',{staticClass:"delete",on:{"click":_vm.removeAnnouncement}}):_vm._e(),_c('p',{staticClass:"announcement",domProps:{"innerHTML":_vm._s(_vm.linkifiedContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }